// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z6H_7","col":"styles_col__1gpoU"};